import { render, staticRenderFns } from "./report-status-patient.vue?vue&type=template&id=3ae9066f"
import script from "./report-status-patient.vue?vue&type=script&lang=js"
export * from "./report-status-patient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports